import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DesignService } from "src/app/design/design.service";
import { Subscription } from "rxjs";
import { Design } from "src/app/design/design.model";
import { MatDialog, MatSnackBar } from "@angular/material";
import { ConfirmationDialogComponent } from "src/app/shared/dialoges/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-design-overview",
  templateUrl: "./design-overview.component.html",
  styleUrls: ["./design-overview.component.css"],
})
export class DesignOverviewComponent {
  private subscription$ = new Subscription();
  showLoader: boolean = false;
  design: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private designService: DesignService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.id) {
        this.getDesingById(queryParams.id);
      }
    });
  }

  /**
   * Get Design Details By Id
   */
  getDesingById(designId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getSingleDesign(designId).subscribe(
        (result: Design) => {
          if (result?.Designs) {
            this.design = result.Designs;
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Design Details. `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Delete Design
   * @param  {String|number} design_id
   */
  delete(design_id: String | number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.showLoader = true;
        this.subscription$.add(
          this.designService.deleteDesign(design_id).subscribe(
            () => {
              this.router.navigate(["/design"]);
              this.showLoader = false;
              this.snackBar.open("Design Deleted Sucessfully.", "", {
                duration: 2000,
              });
            },
            (error) => {
              this.showLoader = false;
              this.snackBar.open(`Error in Deleting Design. `, "", {
                duration: 2000,
              });
            }
          )
        );
      }
    });
  }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
